import React from 'react';

import {serviceMotionList} from '../../utils/serviceMotionList';

import FeatureCardBox from '../common/FeatureCardBox';

import {ReactComponent as DashboardImg} from '../../assets/admin02/dashboard.svg';
import {ReactComponent as DashboardExampleImg} from '../../assets/admin02/dashboard-example.svg';

export default function Admin02() {
    const dataMap = [
        { 
            type: 'admin-dashboard',
            title: '데이터를 활용하세요',
            subTitle: '데이터를 한눈에 확인하고 인사이트를 얻으세요',
            Image: DashboardExampleImg
        }
    ];

    return (
        <FeatureCardBox
            type='admin-dashboard'
            IconImage={DashboardImg}
            keyword='관리자용 대시보드'
            title='활용 현황을 한눈에 확인하세요!'
            featureCardList={dataMap}
            titleMotion={serviceMotionList.titleMotion}
            cardMotion={serviceMotionList.cardMotion}
            motionVariant={serviceMotionList.admin02}
        />
    );
}
